import styled from 'styled-components';

export const Container = styled.li`
  width: 43.9rem;
  height: 6.9rem;
  border-radius: 0.4rem;
  background-color: #fff;

  margin-right: 5.5rem;
  margin-bottom: 4.2rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 4.2rem;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3.2rem;
  cursor: pointer;
  svg {
    transform: scaleX(-1);
  }

  transition: 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const Title = styled.p`
  font-size: 2.1rem;
  font-weight: bold;
`;
